module.exports = __webpack_public_path__ + "assets/img/es-93e05053.png";